import React from 'react';
import FirebaseContext from '../../firebase/context';
import LinkItem from './LinkItem';
import { LINKS_PER_PAGE } from '../../utils/index';
import axios from 'axios';

function LinkList(props) {
  const { firebase } = React.useContext(FirebaseContext);
  const [links, setLinks] = React.useState([]);
  const [cursor, setCursor] = React.useState(null);
  const [totalLinks, setTotalLinks] = React.useState(null);
  const isNewPage = props.location.pathname.includes('new');
  const isTopPage = props.location.pathname.includes('top');
  const page = Number(props.match.params.page); //page see parent app.js
  const [loading, setLoading] = React.useState(false);
  const linksRef = firebase.db.collection('links');


  React.useEffect(() => {
    // firebase.db.collection('links').get();
    getTotalLinks();  // bs fix, write total link in state
    const unsubscribe = getLinks();
    return () => unsubscribe();
  }, [isTopPage, page]);  //dependency, reexecute when isTopPage or page changes!!!

  function getTotalLinks(){
      firebase.db.collection('links').get().then(response => {
        setTotalLinks(response.docs.length);
      })
  }

  function getLinks() {
    setLoading(true);
    const hasCursor = Boolean(cursor);
    //const isTopPage = props.location.pathname.includes('top');  //bring up
    if(isTopPage){  //needs return because unsubscribe...
      return linksRef
        .orderBy('voteCount', 'desc')
        .limit(LINKS_PER_PAGE)
        .onSnapshot(handleSnapshot);
    } else if (page === 1) {
      return (
      linksRef
        .orderBy('created', 'desc')
        //.startAfter(1560680055874)
        //.startAt(1560680055874)
        .limit(LINKS_PER_PAGE)
        .onSnapshot(handleSnapshot)
      );
    } else if (hasCursor) {
      return linksRef
        .orderBy('created', 'desc')
        .startAfter(cursor.created)
        .limit(LINKS_PER_PAGE)
        .onSnapshot(handleSnapshot);
    } else {
      const offset = page * LINKS_PER_PAGE - LINKS_PER_PAGE;
      axios.get(
        `https://us-central1-hooks-news-bs.cloudfunctions.net/linksPagination?offset=${offset}`
      ).then(response => {
        const links = response.data;
        const lastLink = links[links.length - 1];
        setLinks(links);
        setCursor(lastLink);
        setLoading(false);
      })
      return () => {}  //unsubscribe need return an object, otherwise it complains!
    }
  
  }

  function handleSnapshot(snapshot) {
    const links = snapshot.docs.map(doc => {
      return { id: doc.id, ...doc.data() }; //data is a method we have to execute
    });
    //console.log({ links });
    const lastLink = links[links.length - 1];
    setLinks(links);
    setCursor(lastLink);
    setLoading(false);
  }

  // function renderLinks() {
  //   if (isNewPage) {
  //     return links;
  //   }
  //   // sort mutates so wie have to slice first!
  //   const topLinks = links.slice().sort(
  //     (l1, l2) => l2.votes.length - l1.votes.length
  //   );
  //   return topLinks;
  // }

  function visitPreviousPage() {
    if (page > 1) {
      props.history.push(`/new/${page - 1}`)
    }
  }

  function visitNextPage() {
    if (page <= totalLinks / LINKS_PER_PAGE) {
      //only more links than can display on current page
      props.history.push(`/new/${page + 1}`);
    }
    
  }

  const pageIndex = page ? (page - 1) * LINKS_PER_PAGE + 1 : 1;

  return (
    <div style={{ opacity: loading ? 0.25 : 1 }}>
      {links.map((link, index) => (
        <LinkItem
          key={link.id}
          showCount={true}
          link={link}
          //index={index + 1}
          index={index + pageIndex}
        />
      ))}
      {isNewPage && (
        <div className="pagination">
          <div className="pointer mr2" onClick={visitPreviousPage}>
            Zurück
          </div>
          <div className="pointer" onClick={visitNextPage}>
            Vorwärts
          </div>
        </div>
      )}
    </div>
  );
}

export default LinkList;
